import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { APSKey } from '@models/aps-key';
import { CollectionPaths } from '@models/collections';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';

export interface ApsKeysPathParams {
	saleId: string;
	apsId: string;
}

@Injectable({
	providedIn: 'root',
})
export class ApsKeysService extends Repo<APSKey, ApsKeysPathParams> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId: string;

	GetCollectionPath(pathParam: ApsKeysPathParams): string {
		return CollectionPaths.business_matter_aps_keys(
			this.businessId,
			pathParam.saleId,
			pathParam.apsId,
		);
	}

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}
}
